export const HANWHA_API_PATH_PREFIX = 'api/hanwha'

export const ENDPOINTS = {
  auth: {
    currentUser: '/api/studio/users/me',
    signOut: '/api/authentication/logout',
    refresh: '/api/authentication/refresh',
    userInfo: (uuid: string): string => `/api/users/info/${uuid}`,
    oauthCallback: (provider: string): string =>
      `/api/${provider}/auth/signin/callback`,
  },
  hanwha: {
    portfolioNews: `${HANWHA_API_PATH_PREFIX}/portfolio-news`,
    portfolioNewsCompanies: `${HANWHA_API_PATH_PREFIX}/portfolio-news/companies`,
    portfolioNewsDetail: (articleId: string): string =>
      `${HANWHA_API_PATH_PREFIX}/portfolio-news/${articleId}`,
    memberInsights: `${HANWHA_API_PATH_PREFIX}/member-insights`,
    memberInsightProducers: `${HANWHA_API_PATH_PREFIX}/member-insights/producers`,
    memberInsightCategories: `${HANWHA_API_PATH_PREFIX}/member-insights/categories`,
    memberInsightDownload: (fileId: string): string =>
      `${HANWHA_API_PATH_PREFIX}/member-insights/${fileId}/download`,
    documents: `${HANWHA_API_PATH_PREFIX}/documents`,
    fundUpdates: `${HANWHA_API_PATH_PREFIX}/fund-updates`,
    fundUpdateCategories: `${HANWHA_API_PATH_PREFIX}/fund-updates/categories`,
    fundUpdatesStats: `${HANWHA_API_PATH_PREFIX}/fund-updates-stats`,
    fundUpdateDownload: (fileId: string): string =>
      `${HANWHA_API_PATH_PREFIX}/fund-updates/${fileId}/download`,
    policyAcceptance: `${HANWHA_API_PATH_PREFIX}/policy-acceptance`,
    policyAcceptanceCheck: (version: string): string =>
      `${HANWHA_API_PATH_PREFIX}/policy-acceptance/${version}`,
    whyWeInvest: `${HANWHA_API_PATH_PREFIX}/why-we-invest`,
  },
} as const
